import axios from 'axios'
var protobuf = require("protobufjs");

const getDefaultState = () => {
    return {
        cyclers: {},
    }
  }


export const state = getDefaultState()
export const getters = {
    cyclers(state) { return state.cyclers; }
}

export const mutations = {
    setCycler(state, cyclers) {
        state.cyclers = cyclers;
    },
    ClearaState(state) {
        Object.assign(state, getDefaultState())
    }
}

export const actions = {
    PairDevice(state, code) {
        return new Promise((resolve, reject) => {
            axios.get("https://poc.procomcure.com/api/pairing/finish?code="+code, { headers: { Authorization: 'Berear '+state.getters.accessToken} })
            .then((r) => {
                if(r.data.success) {
                    resolve(true);
                    state.dispatch("LoadInitialData");
                }
                if(!r.data.success) reject(false);
            })
            .catch(() => {
                reject(false);
            })
        })
    },
    RefreshStates(state) {
        state.dispatch("LoadInitialData");
    },    
    ClearState(state) {
        state.commit("ClearaState")
    },
    GetCycler(state) {
        axios.get("https://poc.procomcure.com/api/v2/cycler", { responseType: 'arraybuffer', headers: { Authorization: 'Berear '+state.getters.accessToken} })
        .then((r) => {
            var root = protobuf.Root.fromJSON(require("/bundle.json"));
            var Probe = root.lookupType("CyclerList");          
            var message = Probe.decode(Buffer.from(r.data));
            state.commit("setCycler", message.Cycler);
        })
        .catch((e) => {
            if(e.response.status == 400) {
                state.dispatch("ForceRelogin");
            }
        })
    },
    SendDeviceCommand(state, data) {
        axios.post("/api/devices/"+data.device+"/command?cmd="+data.command, { responseType: 'arraybuffer', headers: { Authorization: 'Berear '+state.getters.accessToken} })
        .then(() => {
            state.dispatch("LoadInitialData");
        })
    },
    SetDeviceName(state, data) {
        axios.post("/api/setdevicename", data, { headers: { Authorization: 'Berear '+state.getters.accessToken} })
        .then((r) => {
            state.dispatch("LoadInitialData")
        })
    },
    LoadInitialData(state) {
        state.dispatch("GetCycler");
    }
}


export default {
    namespaced: false,
    state,
    getters,
    actions, 
    mutations
  }